import { useEffect } from 'react';
import type { IMoodRecordDraft } from '../../../shared/types/mood';
import { parsePathname, redirect, useLocation } from '../../features/routing';
import { useMoodRecordDraft } from '../../lib/moodUtils/MoodRecordDraftContext';
import { MoodLogEntryStep1Page } from './step1/MoodLogEntryStep1Page';
import { MoodLogEntryStep2Page } from './step2/MoodLogEntryStep2Page';
import { MoodLogEntryStep3Page } from './step3/MoodLogEntryStep3Page';
import { MoodLogEntryStep4Page } from './step4/MoodLogEntryStep4Page';
import { MoodLogEntryStep5Page } from './step5/MoodLogEntryStep5Page';

export const MoodLogEntryPage = () => {
  const { moodRecordDraft, initializeDraft } = useMoodRecordDraft();
  const location = useLocation();
  const stepNumber = parsePathname(location).stepNumber;

  useEffect(() => {
    if (!moodRecordDraft) {
      initializeDraft();
    } else {
      console.log(
        `%cthis is the moodRecordDraft:`,
        'background:pink; color:black;',
        moodRecordDraft
      );
    }
  }, [initializeDraft, moodRecordDraft]);

  if (stepNumber === 1) {
    return <MoodLogEntryStep1Page />;
  } else if (stepNumber === 2) {
    return <MoodLogEntryStep2Page />;
  } else if (stepNumber === 3) {
    return <MoodLogEntryStep3Page />;
  } else if (stepNumber === 4) {
    return <MoodLogEntryStep4Page />;
  } else if (stepNumber === 5) {
    return <MoodLogEntryStep5Page />;
  }

  redirect(getAppropriateStep(moodRecordDraft));
};

function getAppropriateStep(moodRecordDraft: IMoodRecordDraft | null) {
  const { emotions, triggers, note, imagePath, mood } = moodRecordDraft || {};

  if (imagePath || note) {
    return '/mood-log-entry/step5';
  } else if (!isEmptyArrayOrUndefined(triggers)) {
    return '/mood-log-entry/step4';
  } else if (!isEmptyArrayOrUndefined(emotions)) {
    return '/mood-log-entry/step3';
  } else if (mood) {
    return '/mood-log-entry/step2';
  }
  return '/mood-log-entry/step1';
}

function isEmptyArrayOrUndefined(array: unknown[] | undefined): boolean {
  return !array || (Array.isArray(array) && array.length === 0);
}
